import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

// Mapeo de rutas a módulos de permisos (debe coincidir con Sidebar.tsx)
const routePermissionMap: Record<string, string> = {
  '/dashboard': 'dashboard',
  '/pos': 'pos',
  '/cash-register': 'cash_register',
  '/void-sales': 'void_sales',
  '/customers': 'customers',
  '/promotions': 'promotions',
  '/products': 'products',
  '/ingredients': 'ingredients',
  '/locations': 'locations',
  '/employees': 'employees',
  '/suppliers': 'suppliers',
  '/stock-config': 'stock_config',
  '/system-parameters': 'system_parameters',
  '/purchase-orders': 'purchase_orders',
  '/distribution': 'distribution',
  '/inventory': 'inventory',
  '/kardex': 'kardex',
  '/transformations': 'transformations',
  '/accounts-payable': 'accounts_payable',
  '/merchandise-movements': 'merchandise_movements',
  '/bread-transfers': 'bread_transfers',
  '/vouchers/manage': 'vouchers',
  '/reports': 'reports'
};

// Orden de prioridad de rutas (el orden en que se muestran en el menú)
const routePriority = [
  '/dashboard',
  '/pos',
  '/cash-register',
  '/void-sales',
  '/customers',
  '/promotions',
  '/products',
  '/ingredients',
  '/locations',
  '/employees',
  '/suppliers',
  '/stock-config',
  '/system-parameters',
  '/purchase-orders',
  '/distribution',
  '/inventory',
  '/kardex',
  '/transformations',
  '/accounts-payable',
  '/merchandise-movements',
  '/bread-transfers',
  '/vouchers/manage',
  '/reports'
];

export const RootRedirect: React.FC = () => {
  const { isAuthenticated, selectedLocation, user } = useAuth();

  if (isAuthenticated && selectedLocation) {
    // Buscar la primera ruta accesible basada en permisos
    const firstAccessibleRoute = getFirstAccessibleRoute(user?.permisos);
    console.log('🔀 Redirecting to first accessible route:', firstAccessibleRoute);
    return <Navigate to={firstAccessibleRoute} replace />;
  }

  return <Navigate to="/login" replace />;
};

// Función para obtener la primera ruta accesible
function getFirstAccessibleRoute(permisos: any[] | undefined): string {
  if (!permisos || !Array.isArray(permisos) || permisos.length === 0) {
    // Si no hay permisos definidos, ir a dashboard por defecto
    return '/dashboard';
  }

  // Buscar la primera ruta que el usuario tenga permiso
  for (const route of routePriority) {
    const requiredModule = routePermissionMap[route];
    if (!requiredModule) {
      // Si la ruta no requiere permiso específico, está permitida
      return route;
    }

    // Verificar si el usuario tiene permiso para este módulo
    const hasPermission = permisos.some((permiso: any) => permiso.module === requiredModule);
    if (hasPermission) {
      return route;
    }
  }

  // Fallback: si no se encuentra ninguna ruta permitida, ir a dashboard
  return '/dashboard';
}